import AffiliationRow from "./AffiliationRow";
import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button } from "react-bootstrap";

@inject("affiliationStore")
@observer
export default class MembershipsTableBody extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { affiliationStore } = this.props;
    return (
      <tbody>
        {affiliationStore.invitations.map((e, idx) => (
          <AffiliationRow invitation={e} key={idx} />
        ))}
      </tbody>
    );
  }
}
